import { render, staticRenderFns } from "./PPIView.vue?vue&type=template&id=7f6be8a7&"
import script from "./PPIView.vue?vue&type=script&lang=js&"
export * from "./PPIView.vue?vue&type=script&lang=js&"
import style0 from "./PPIView.vue?vue&type=style&index=0&id=7f6be8a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports